import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal
} from '@angular/core';
import { Observable, map, startWith, tap } from 'rxjs';
import { ImportTaskService } from '~core/services/import-task.service';
import { ROUTES } from '../../constants/routes.constants';
import { InvoiceFormComponent } from '../modals/invoice-form/invoice-form.component';
import { BaseComponent } from '../../abstract-components/base.component';
import { DashboardService } from '~core/services/dashboard.service';
import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'toolbar',
  standalone: false,
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarComponent extends BaseComponent {
  private _breakpointObserver = inject(BreakpointObserver);
  private _importTaskService = inject(ImportTaskService);
  private _appRef = inject(ApplicationRef);
  private _dashboardService = inject(DashboardService);
  private _document = inject(DOCUMENT);

  readonly establishmentsRoute = ROUTES.establishments;

  avatarUrl = input<string>('/assets/icons/admin.svg');
  roleVisible = input<boolean>(true);
  currentUser$ = this._authFacade.currentUser$;
  isLoggingOut$ = this._authFacade.isLoggingOut$;
  isHandset$: Observable<boolean> = this._breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  isLayoutHidden$ = this._globalFacade.routeData$.pipe(
    map(routeData =>
      routeData ? routeData.data?.layoutHidden === true : false
    ),
    startWith(true)
  );

  tasksCount$ = this._importTaskService
    .list({ status: 'in(pending,running)' })
    .pipe(map(result => result.fullyItems));

  isSidenavCollapsed = false;
  routes = ROUTES;

  isLoadingSupersetOAuthData = signal(false);

  logout(): void {
    this._authFacade.logout();
  }

  openInvoiceFormModal(): void {
    this._dialogService.openSheet(InvoiceFormComponent, {
      panelClass: [
        'mat-dialog-custom',
        'drawer',
        'slide-in-right',
        'w-[800px]'
      ],
      disableClose: false,
      maxWidth: '800px'
    });
  }

  toggleSidenav(): void {
    this.isSidenavCollapsed = !this.isSidenavCollapsed;
    setTimeout(() => {
      this._appRef.tick();
    }, 100);
  }

  navigateToSuperset(): void {
    this.isLoadingSupersetOAuthData.set(true);
    this._dashboardService
      .getSuperSetOAuthUrl()
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: url => {
            this._document.defaultView?.open(
              url,
              '_blank',
              'noopener noreferrer'
            );
          },
          finalize: () => {
            this.isLoadingSupersetOAuthData.set(false);
          }
        })
      )
      .subscribe();
  }

  navigateToPortal(): void {
    this._document.defaultView?.open(
      this._constantsService.environment.postalDomainBasePathUrl,
      '_blank',
      'noopener noreferrer'
    );
  }
}
